// @flow
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { openContactModal } from '../../actions/modals'
import PageHeader from '../../components/PageHeader'
import Agent from './components/Agent'
import agents from '../../data/agents'

type Props = {
  openContactModal: Function
}

const Agents = (
  { openContactModal }: Props // eslint-disable-line no-shadow
) => (
  <div style={{ background: '#fff' }}>
    <Helmet title="Our Team" />
    <PageHeader text="Our Team">
      Kief Realty team members partner with you throughout your home search and
      the entire buying process, providing their professional expertise and
      guidance every step of the way.
    </PageHeader>
    <div className="container">
      <div className="row">
        {agents.map((agent) => (
          <div className="col-lg-4 col-md-6 col-xs-12" key={agent.id}>
            <Agent
              name={agent.name}
              image={agent.image}
              titles={agent.titles}
              email={agent.email}
              bio={agent.bio}
              openContactModal={openContactModal}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default connect(
  null,
  { openContactModal }
)(Agents)



// WEBPACK FOOTER //
// ./src/views/Agents/index.js